import { string, boolean, object, bool } from "yup";

export const ProductCouleurSchema = object().shape({
  libelle: string().required("Libellé obligatoire!!"),
  code_couleur: string().required("code_couleur obligatoire!!"),
  _id: string().notRequired(),
  organisation_id: string().notRequired(),
});
